<template>
  <div class="jsc-bg">
    <!-- <div class="imgbg"></div> -->
    <!-- 顶部 -->
    <div class="top">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">课程考勤预警驾驶舱</div>
      <div class="sys-temp"><div id="he-plugin-simple"></div></div>
    </div>
    <my-scale @changeSize="changeSize">
      <div
        class="all"
        style="height: 1080px"
        :style="{
          'margin-top': 'calc(' + mySize + 'vw',
        }"
      >
        <div class="left">
          <div class="left-top">
            <left-top :TodaySigninData="TodaySigninData" :dayDate="dayDate" @changeDayDate="changeDayDate"></left-top>
          </div>
          <div class="left-bottom">
            <left-bottom :TermSigninData="TermSigninData" :termList="termList" @changeTerm="changeTerm"></left-bottom>
          </div>
        </div>
        <div class="curr-center">
          <div class="center-top">
            <center-top :weekSigninData="weekSigninData" :termSignData="termSignData"></center-top>
          </div>
          <div class="center-bottom">
            <center-bottom
              :termAttendanceRate="termAttendanceRate"
              :termList="termList"
              @changeTerm="changeTerm"
            ></center-bottom>
          </div>
        </div>
        <div class="right">
          <div class="right-top"><right-top :kkData="kkData"></right-top></div>
          <div class="right-bottom">
            <right-bottom :itemData="itemData" :termList="termList" @changeTerm="changeTerm"></right-bottom>
          </div>
        </div>
      </div>
    </my-scale>
  </div>
</template>
<script>
import LeftTop from './components/AttendLefttop.vue'
import LeftBottom from './components/AttendLeftbottom.vue'
import CenterTop from './components/AttendCentertop.vue'
import CenterBottom from './components/AttendCenterbottom.vue'
import RightTop from './components/AttendRighttop.vue'
import RightBottom from './components/AttendRightbottom.vue'
import MyScale from './components/MyScale.vue'
import {
  getDayCollegeSignInfo,
  getTermCollegeSignInfo,
  getWeekSignInfo,
  getTermAttendanceRate,
  getFocusOnStudents_KK,
  getTermItemSignInfo,
  getTermSignInfo,
  getTermList,
} from '@/api/api-sign.js'

export default {
  name: '',
  components: {
    LeftTop,
    LeftBottom,
    CenterTop,
    CenterBottom,
    RightTop,
    RightBottom,
    MyScale,
  },
  directives: {},
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      today: '',
      timer: null,
      showOne: false,
      showTwo: false,
      showCenter: false,
      showThree: false,
      showFour: false,
      percent: 50,
      TodaySigninData: [], //今日各学院考勤情况
      TermSigninData: [], //学期各学院考勤情况
      weekSigninData: [],
      termAttendanceRate: [],
      kkData: [],
      itemData: [],
      termSignData: {},
      dayDate: '',
      termList: [
        // { name: '2023-2024学期,春夏学期', id: '1' },
        // { name: '2022-2023学期,秋冬学期', id: '2' },
      ],
      currTermId: '',
    }
  },
  created() {
    let getMyDate = new Date()
    this.dayDate = this.formatDate(getMyDate.getTime())
    window.addEventListener('load', this.placeholderPic)
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 9 ? date.month : '0' + date.month
    let newday = date.date > 9 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday
    //数据请求
    this.getTermListData()
    this.getTodaySignin()
    this.getTermSignin()
    this.getWeekSignin()
    this.getTermAttendance()
    this.getFocusOnStudents()
    this.getTermItemSignInfoData()
    this.termSignInfo()
    this.timer = setInterval(() => {
      this.getTodaySignin()
      this.getTermSignin()
      this.getWeekSignin()
      this.getTermAttendance()
      this.getFocusOnStudents()
      this.getTermItemSignInfoData()
      this.termSignInfo()
    }, 60000)
  },
  mounted() {
    window.WIDGET = {
      CONFIG: {
        modules: '02',
        background: '5',
        tmpColor: 'FFFFFF',
        tmpSize: '16',
        cityColor: 'FFFFFF',
        citySize: '16',
        aqiColor: 'FFFFFF',
        aqiSize: '16',
        weatherIconSize: '24',
        alertIconSize: '18',
        padding: '10px 10px 10px 10px',
        shadow: '0',
        language: 'auto',
        fixed: 'false',
        vertical: 'top',
        horizontal: 'left',
        key: '18dcc59e188b4b6684d470c4322bbefa',
      },
    }
    ;(function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
      var s = d.createElement('script')
      s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  methods: {
    getTermListData() {
      getTermList().then((res) => {
        if (res.data.statusCode == 1) {
          this.termList = res.data.obj
          this.currTermId = this.termList[0].id
        }
      })
    },
    formatDate(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}-${day}`
      return formattedDate
    },
    changeSize(size) {
      console.log('size:', size)
      this.currScale = size
      this.mySize = 5.208 / size
    },
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    termSignInfo() {
      getTermSignInfo().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('考勤统计：', res)
          this.termSignData = res.data.obj
        }
      })
    },
    getTodaySignin() {
      getDayCollegeSignInfo(this.dayDate).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('今日考勤：', res)
          this.TodaySigninData = res.data.obj
        }
      })
    },
    getTermSignin() {
      getTermCollegeSignInfo(this.currTermId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('学期考勤：', res)
          this.TermSigninData = res.data.obj
        }
      })
    },
    getWeekSignin() {
      getWeekSignInfo().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getWeekSignin', res)
          this.weekSigninData = res.data.obj
        }
      })
    },
    getTermAttendance() {
      getTermAttendanceRate(this.currTermId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.termAttendanceRate = res.data.obj
        }
      })
    },
    getFocusOnStudents() {
      getFocusOnStudents_KK().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('kkdata:', res)
          this.kkData = res.data.obj
        }
      })
    },
    getTermItemSignInfoData() {
      getTermItemSignInfo(this.currTermId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getTermItemSignInfo:', res)
          this.itemData = res.data.obj
        }
      })
    },
    changeDayDate(date) {
      console.log('changeDayDate222:', date)
      this.dayDate = date
      this.getTodaySignin()
    },
    changeTerm(term, type) {
      this.currTermId = term
      console.log('changeTerm:', term, type)
      if (type == 'left') {
        this.getTermSignin()
      } else if (type == 'center') {
        this.getTermAttendance()
      } else if (type == 'right') {
        this.getTermItemSignInfoData()
      }
    },
  },
  destroyed() {
    clearInterval(this.timer)
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/css/academic.scss';
.top {
  background: url('../../assets/img/cockpit/top.svg') no-repeat;
}
.imgbg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  //   background: url('../../assets/img/academic/mbg.svg') no-repeat;
  background-size: 100%;
}
.left-top {
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 0%, rgba(0, 122, 77, 0) 100%);
}
.left-bottom {
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 0%, rgba(0, 122, 77, 0) 100%);
}
.right-top {
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 0%, rgba(0, 122, 77, 0) 100%);
}
.right-bottom {
  margin-top: 16px;

  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 0%, rgba(0, 122, 77, 0) 100%);
}
.sys-temp ::v-deep .s-sticker-tmp {
  font-size: 0.5rem !important;
}
.sys-temp ::v-deep img {
  height: 0.7rem !important;
  width: 0.7rem !important;
}

.left,
.right,
.curr-center {
  height: 100% !important;
}
.left {
  width: 560px;
}
.curr-center {
  width: 800px;
}
.right {
  width: 560px;
}
.left-bottom,
.left-top,
.center-top,
.center-bottom,
.right-bottom,
.right-top {
  height: 413px;
  background: linear-gradient(180deg, rgba(26, 135, 95, 0.045) 0%, rgba(0, 122, 77, 0.09) 100%);
  margin: 16px;
  padding: 16px;
}
.center-top,
.center-bottom {
  margin: 16px 8px;
}
.left-bottom,
.left-top {
  margin: 16px 8px 16px 16px;
}
.right-bottom,
.right-top {
  margin: 16px 16px 16px 8px;
}

.all {
  width: 1920px;
  display: flex;
}
</style>
